// extracted by mini-css-extract-plugin
module.exports = {"QuestionGroup":"QuestionGroup_QuestionGroup___riAS"};